import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaCheckCircle } from 'react-icons/fa';
import useAccept from './useAccept';
import ActionButtonGradient from '../../../components/button/ActionButtonGradient';

const AcceptModal = ({show, handleClose, user, setLoadingPage}) => {
  const{
    setPayload,
    handleAccept,
  } = useAccept()
  useEffect(() => {
    if (user) {
      setPayload((prev) => ({
        ...prev,
        ProjectID: user.ProjectID,
        EmployeeID: user.EmployeeID,
        ProjectPhaseID: user.ProjectPhaseID,
        CalibratorID: user.CalibratorID,
      }))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])
  
  return (
    <>
      <style>
        {`
          .accept-modal .modal-content {
            border: none;
            border-radius: 12px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          .accept-modal .modal-header {
            border-bottom: 1px solid #e9ecef;
            padding: 1.5rem 1.5rem 1rem 1.5rem;
            background-color: #fff;
            border-radius: 12px 12px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .accept-modal .modal-title {
            font-weight: 600;
            color: #333;
            font-size: 1.125rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0;
          }
          .accept-modal .modal-body {
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            font-size: 14px;
            color: #666;
            line-height: 1.5;
            text-align: center;
          }
          .accept-modal .modal-footer {
            border-top: 1px solid #e9ecef;
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            border-radius: 0 0 12px 12px;
            display: flex;
            gap: 0.5rem;
            justify-content: center;
          }
          .accept-modal .btn {
            border-radius: 8px;
            padding: 0.5rem 1.25rem;
            font-weight: 500;
            font-size: 14px;
            transition: all 0.2s ease;
          }
          .accept-modal .btn-success {
            background-color: #28a745;
            border-color: #28a745;
            color: white;
          }
          .accept-modal .btn-success:hover {
            background-color: #218838;
            border-color: #1e7e34;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
          }
          .accept-modal .btn-secondary {
            background-color: #6c757d;
            border-color: #6c757d;
            color: white;
          }
          .accept-modal .btn-secondary:hover {
            background-color: #5a6268;
            border-color: #545b62;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
          }
          .accept-icon {
            color: #28a745;
            font-size: 1.125rem;
          }
        `}
      </style>
      
      <Modal 
        show={show} 
        onHide={handleClose}
        backdrop="static" 
        centered
        size="md"
        className="accept-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <FaCheckCircle className="accept-icon" />
            Accept Calibration
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">Are you sure you want to accept this calibration request?</p>
        </Modal.Body>
        <Modal.Footer>
          <ActionButtonGradient
            variant="secondary"
            onClick={handleClose}
            children={"Cancel"}
          />
          <ActionButtonGradient
            variant="success"
            onClick={() => {
              handleClose()
              handleAccept(setLoadingPage)
            }}
            children={"Accept"}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AcceptModal